import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setQuotationParams, cleanComparisonPlans } from '../../../actions/searchActions';

import SearchIcon from './SearchIcon';
import Frame from '../../../lib/sp_frame';

import {
  formatURL,
  showDateVerbose,
  cleanDate,
  getDaysDiff,
  getDestinationSlugByName,
  buildSearchWithDestinationCategories,
} from '../../../utils';
import dataLayer from '../../../utils/dataLayer';

const addClass = (el, className) => {
  el.classList.add(className);
};

const rmClass = (el, className) => {
  el.classList.remove(className);
};

const addAttr = (el, attrName, attrValue) => {
  el.setAttribute(attrName, attrValue);
};

const rmAttr = (el, attrName) => {
  el.removeAttribute(attrName);
};

const init = (component, initialValues) => {
  const destinationInput = document.querySelector('#destinationSp');
  const departureDateInput = document.querySelector('#departureDateInput');
  const departureDateContainer = document.querySelector('#departureDateContainer');
  const returningDateInput = document.querySelector('#returningDateInput');
  const returningDateContainer = document.querySelector('#returningDateContainer');
  const mobile = window.innerWidth <= 800;

  const destination = new Frame.Destination({
    initialValue: initialValues.destination,
    input: destinationInput,
    onError: {
      INVALID_VALUE: () => {
        addClass(destinationInput, 'is-danger');
      },
    },
    onChange: () => {
      rmClass(destinationInput, 'is-danger');
      component.handleChange({ target: { name: 'destination', value: destination.getSelected().slug } });
    },
  });



  const departureDate = new Frame.Period({
    input: departureDateInput,
    dateContainer: departureDateContainer,
    container: document.getElementById('ex-input-departure'),
    multipleCalendars: true,
    startDatePicker: true,
    onShow(frame, drop) {
      addClass(departureDateContainer, 'ex-inputs-picker-visible');
      drop === 'up'
        ? addClass(departureDateContainer, 'ex-inputs-picker-up')
        : rmClass(departureDateContainer, 'ex-inputs-picker-up');
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
    },
    onChange() {
      rmClass(departureDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE(Frame) {
        departureDateInput.value = '';
        component.handleChange({ target: { name: 'begin_date', value: '' } });
        addClass(departureDateInput, 'is-danger');
      },
    },
    onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(departureDateContainer, 'ex-inputs-picker-visible');
      rmClass(departureDateContainer, 'ex-inputs-picker-up');
    },
    onSelect(Frame) {
      if (frame.departureDate.datePicker.state.start) {
        component.handleChange({
          target: { name: 'begin_date', value: Frame.departureDate.datePicker.state.start.toPtBr() },
        });
        this.input.value = mobile
          ? Frame.departureDate.datePicker.state.start.toPtBr()
          : showDateVerbose(Frame.departureDate.datePicker.state.start.toPtBr());

        frame.returningDate.validate();
      }
    },
  });

  const returningDate = new Frame.Period({
    input: returningDateInput,
    dateContainer: returningDateContainer,
    container: document.getElementById('ex-input-return'),
    multipleCalendars: true,
    startDatePicker: false,
    onShow(frame, drop) {
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
      addClass(returningDateContainer, 'ex-inputs-picker-visible');
      drop === 'up'
        ? addClass(returningDateContainer, 'ex-inputs-picker-up')
        : rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onChange(Frame) {
      rmClass(returningDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE(Frame) {
        returningDateInput.value = '';
        component.handleChange({ target: { name: 'end_date', value: '' } });
        addClass(returningDateInput, 'is-danger');
      },
    },
    onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(returningDateContainer, 'ex-inputs-picker-visible');
      rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onDisable() {
      addAttr(returningDateInput, 'disabled', 'disabled');
    },
    onEnable() {
      rmAttr(returningDateInput, 'disabled');
    },
    onSelect(Frame) {
      if (frame.returningDate.datePicker.state.end) {
        component.handleChange({
          target: { name: 'end_date', value: Frame.returningDate.datePicker.state.end.toPtBr() },
        });
        this.input.value = mobile
          ? Frame.returningDate.datePicker.state.end.toPtBr()
          : showDateVerbose(Frame.returningDate.datePicker.state.end.toPtBr());
      }
    },
  });

  let frame = new Frame.Frame({
    destination,
    departureDate,
    returningDate,
    client: false,
    openInNewTab: false,
  });

  const beginDate = new Date(
    parseInt(initialValues.begin_date.split('/')[2], 0),
    parseInt(initialValues.begin_date.split('/')[1], 0) - 1,
    parseInt(initialValues.begin_date.split('/')[0], 0)
  );
  const endDate = new Date(
    parseInt(initialValues.end_date.split('/')[2], 0),
    parseInt(initialValues.end_date.split('/')[1], 0) - 1,
    parseInt(initialValues.end_date.split('/')[0], 0)
  );

  frame.departureDate.setStartDate(beginDate);
  frame.returningDate.setStartDate(beginDate);
  frame.departureDate.setEndDate(endDate);
  frame.returningDate.setEndDate(endDate);
};

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      destination: props.match.params.destination || '',
      begin_date: cleanDate(props.match.params.begin_date) || '',
      end_date: cleanDate(props.match.params.end_date) || '',
      destinationSelectOpen: false,
      destinations: props.destinations || [],
    };

    this.init = init.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchPlan = this.searchPlan.bind(this);
    this.setQuotationParams = this.props.setQuotationParams.bind(this);
  }

  componentDidMount() {
    this.init(this, {
      destination: this.getDestinationDisplay(this.state.destination),
      begin_date: this.formatDate(this.state.begin_date),
      end_date: this.formatDate(this.state.end_date),
    });
  }

  getDestinationDisplay(slug) {
    const display = this.props.destinations.filter((destination) => destination.slug === slug);

    if (display.length === 0) return this.state.destination;

    return display[0].name;
  }

  formatDate(date) {
    const spl = date.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!spl) return '';

    return `${spl[3]}/${spl[2]}/${spl[1]}`;
  }

  dateDifference = (startDate, endDate) => {
    var date1 = new Date(startDate);
    var date2 = new Date(endDate);
    var difference_In_Time = date2.getTime() - date1.getTime();
    var difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
    return difference_In_Days;
  };

  searchPlan() {
    const destination = getDestinationSlugByName(this.state.destination) || this.state.destination.toLocaleLowerCase();


    if (this.formatDate(this.state.begin_date) !== '' && this.formatDate(this.state.end_date) !== '') {
      this.props.cleanComparisonPlans();
      // this.props.filterPlansMobile();

      const search = buildSearchWithDestinationCategories(this.props.destinations, destination);

      const path = formatURL(
        this.props.match.params,
        `/pesquisa/${destination}/${this.state.begin_date}/${this.state.end_date}`,
        search,
        !search
      );
      this.props.history.push(path);
    }
    dataLayer.raw({
      event: 'envio_form_cotacao',
      page_category: 'home',
      tipo_envio: 'novo_lead',
      cotacao: {
        destino: destination,
        data_embarque: this.state.begin_date,
        data_desembarque: this.state.end_date,
        tempo_permanencia: this.dateDifference(this.state.begin_date, this.state.end_date),
      },
    });
    dataLayer.searchSubmitted(destination, this.state.begin_date, this.state.end_date);
  }

  handleChange(e) {
    if (e.target.name === 'begin_date' || e.target.name === 'end_date') {
      const spl_date = e.target.value.split('/');
      const val = `${spl_date[2]}-${spl_date[1]}-${spl_date[0]}`;
      e.target.value = val;
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const diffDays = getDaysDiff(new Date(this.state.begin_date), new Date(this.state.end_date));

    return (
      <div className="component">
        <section className="filtro flex section-search">
          <p className="you-search">Você pesquisou por:</p>
          <form className="flex buscar-destino " id="date_container">
            <div htmlFor="continente" className="group">
              <label htmlFor="destiny" className="label-content label-destiny" data-title="Destino">
                <input
                  id="destinationSp"
                  className="control destiny"
                  type="text"
                  name="destination"
                  value={this.getDestinationDisplay(this.state.destination)}
                  readOnly
                  data-cy="search-frame-destino"
                />
                <img src="/assets/images/icons/arrowUp.svg" alt="icone seta" className="label-destiny-chevron" />
              </label>
            </div>

            <div id="ex-input-departure" className="ex-inputs group">
              <label htmlFor="departureDateInput" className="label-content" data-title="Partida">
                <input
                  className="control go"
                  name="departureDate"
                  value={showDateVerbose(this.state.begin_date) || 'Ida'}
                  type="text"
                  id="departureDateInput"
                  readOnly
                  data-cy="search-frame-partida"
                />
              </label>
              <div id="departureDateContainer" className="ex-inputs-picker"></div>
            </div>

            <div id="ex-input-return" className="ex-inputs group">
              <label htmlFor="returningDateInput" className="label-content" data-title="Retorno">
                <input
                  className="control return last-back"
                  name="returningDate"
                  value={showDateVerbose(this.state.end_date) || ''}
                  type="text"
                  id="returningDateInput"
                  readOnly
                  data-cy="search-frame-retorno"
                />
              </label>
              <div id="returningDateContainer" className="ex-inputs-picker"></div>
            </div>

            <div className="group">
              <label className="ic-button">
                <button
                  type="button"
                  name="submit"
                  value=""
                  className="button-search update"
                  id="searchBtn"
                  onClick={this.searchPlan}
                  data-cy="search-frame-pesquisar"
                >
                  <span>
                    <SearchIcon />
                    Buscar
                  </span>
                </button>
              </label>
            </div>
          </form>
          <p className="days-permanence">Permanência: {!Number.isNaN(diffDays) && diffDays + ' dias'}</p>
        </section>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      destinations: state.global.destinations,
    }),
    {
      setQuotationParams,
      cleanComparisonPlans,
    }
  )(SearchBar)
);



// WEBPACK FOOTER //
// ./src/components/search/searchbar/SearchBar.jsx